import React, { PureComponent } from 'react';
import PT from 'prop-types';
import { ReactFormGroupWrapper } from './reactformgroupwrapper';
import { map } from 'lodash';
import { getObjectPropertyValue } from './util';

export class ReactFormFieldOneOfInput extends PureComponent {
    constructor(props) {
        super(props);

        this.handleRadioChange = this.handleRadioChange.bind(this);
        this.handleSelectChange = this.handleSelectChange.bind(this);
    }

    handleRadioChange(e) {
        if(this.props.onChange)
            this.props.onChange(e.target.name);
    }

    handleSelectChange(e) {
        if(this.props.onChange)
            this.props.onChange(e.target.value);
    }
    
    render() {            
        let selector;
        if(this.props.possibleValues.length > 6) {
            const DropdownView = this.props.viewProvider.getDropdownView();
            
            selector = (
                <DropdownView
                    value={this.props.value}
                    possibleValues={this.props.possibleValues}
                    onChange={this.handleSelectChange}
                    isRequired={this.props.isRequired}
                    lang={this.props.lang}
                    isInvalid={this.props.showValidationErrors}
                />
            );
        } else {
            const RadioButtonView = this.props.viewProvider.getRadioButtonView();
            const itemsCtl = map(this.props.possibleValues, (val, i) => {
                const label = getObjectPropertyValue(val, 'label', this.props.lang);
                return (
                    <div key={i}>
                        <RadioButtonView
                            name={val.value} 
                            checked={this.props.value === val.value}
                            label={label}
                            onChange={this.handleRadioChange}
                            isRequired={this.props.isRequired}
                            isInvalid={this.props.showValidationErrors}
                        />
                    </div>
                );
            });
            selector = <div>{itemsCtl}</div>;
        }


        return (
            <ReactFormGroupWrapper {...this.props}>
                {selector}
            </ReactFormGroupWrapper>
        );
    }
}

ReactFormFieldOneOfInput.propTypes = {
    name: PT.string.isRequired,
    value: PT.any,
    possibleValues: PT.arrayOf(PT.shape({
        label: PT.oneOfType([PT.string, PT.shape({ fr: PT.string, en: PT.string })]).isRequired,
        value: PT.any
    })),
    viewProvider: PT.object,
    onChange: PT.func,
    validationErrors: PT.array,
    showValidationErrors: PT.bool,
    isRequired: PT.bool,
    lang: PT.string
};

ReactFormFieldOneOfInput.defaultProps = {
    value: ""
};
